export function getGitHubIcon(): JQuery {
    return $('<span class="github-icon bowtie-icon bowtie-brand-github flex-noshrink"></span>');
}
